import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import { useDispatch, useSelector } from 'react-redux';
import { useFirestore } from 'react-redux-firebase';
import { Box, Pagination, TextField, useMediaQuery } from '@mui/material';
import collections from '../../../constants/FirestoreCollections';
import { toUpper } from 'lodash';
import { standardString } from '../../../utils/utils';
import { actions } from '../../../actions';
import Text from '../../../shared/Text';
import { obraSocialSM } from '../../../constants/Inputs';
import Message from '../components/Message';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
const MySwal = withReactContent(Swal);

const useStyles = (small) =>
  makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    filtersContainer: {
      marginTop: theme.spacing(1),
    },
    addButtonContainer: {
      height: '100%',
    },
    form: {
      marginTop: theme.spacing(1),
    },
    formControl: {
      minWidth: 120,
    },
    submitButtonContainer: {
      marginTop: theme.spacing(3),
    },
    addLy: {
      margin: !small && '16px',
      marginTop: small && '16px',
    },
  }));

function OSMessages() {
  const small = useMediaQuery('(max-width:600px)');
  const classes = useStyles(small)();
  const firestore = useFirestore();
  const profile = useSelector((state) => state.firebase.profile);
  const organization = useSelector((state) => state.app.organization);
  const messages = useSelector((state) => state.app.messages);
  const configuration = useSelector((state) => state.app.labelsConfiguration);
  const config = useSelector((state) => state.app.prestobotsConfig);
  const appDispatch = useDispatch();

  const [showAddOSMessage, setShowAddOSMessage] = useState(false);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (page !== 1) {
      setPage(1);
    }
  }, [search]);

  const newOSMessage = (message) => {
    if (insurancesMessages.find((e) => standardString(e.value) === standardString(message.value))) {
      appDispatch({
        type: actions.alert,
        alert: {
          snackbarOpen: true,
          snackbarMessage: `Ya existe un mensaje igual`,
          snackbarSeverity: 'error',
        },
      });
      appDispatch({
        type: actions.changeLoading,
        loading: { loading: false, priority: 1 },
      });
      return;
    }
    firestore
      .collection(collections.messages)
      .add({
        ...message,
        value: toUpper(message.value),
        type: 'insurance',
        organizationId: organization.id,
        updatedAt: new Date(),
      })
      .finally(() =>
        appDispatch({
          type: actions.changeLoading,
          loading: { loading: false, priority: 1 },
        }),
      );
  };

  const updateOSMessage = (message, id) => {
    firestore
      .collection(collections.messages)
      .doc(id)
      .update({ ...message, updatedAt: new Date() })
      .finally(() => {
        appDispatch({
          type: actions.changeLoading,
          loading: { loading: false, priority: 1 },
        });
      });
  };

  const handleDelete = ({ id }) => {
    MySwal.fire({
      text: '¿Esta seguro que quiere borrarlo?',
      showConfirmButton: true,
      showDenyButton: true,
      icon: 'error',
    }).then((result) => {
      if (result.isConfirmed) {
        appDispatch({
          type: actions.changeLoading,
          loading: { loading: true, priority: 1 },
        });
        firestore
          .collection(collections.messages)
          .doc(id)
          .delete()
          .finally((res) => {
            appDispatch({
              type: actions.changeLoading,
              loading: { loading: false, priority: 1 },
            });
          });
      }
    });
  };

  const handleSubmit = ({ id, ...systemMessage }, mode) => {
    appDispatch({
      type: actions.changeLoading,
      loading: { loading: true, priority: 1 },
    });
    switch (mode) {
      case 'create':
        newOSMessage(systemMessage);
        break;
      case 'update':
        updateOSMessage(systemMessage, id);
        break;
      default: {
        appDispatch({
          type: actions.changeLoading,
          loading: { loading: false, priority: 1 },
        });
      }
    }
  };

  const inputsCreate = obraSocialSM(
    [],
    [],
    [],
    (config && [
      ...config.states
        ?.filter(
          (state) => organization && organization.states && organization.states.includes(state.key),
        )
        .map((state) => ({ value: parseInt(state.key), label: state.label })),
      { value: 3, label: 'terminado' },
    ]) ||
      [],
    true,
  );
  const inputsUpdate = obraSocialSM(
    [],
    [],
    [],
    (config && [
      ...config.states
        ?.filter(
          (state) => organization && organization.states && organization.states.includes(state.key),
        )
        .map((state) => ({ value: parseInt(state.key), label: state.label })),
      { value: 3, label: 'terminado' },
    ]) ||
      [],
    false,
  );
  const insurancesMessages = (messages && messages.filter((e) => e.type === 'insurance')) || [];

  const filteredMessages = insurancesMessages
    .filter((osMessage) => {
      return !search
        ? true
        : standardString(osMessage.value).indexOf(standardString(search)) !== -1 ||
            standardString(osMessage.acronym).indexOf(standardString(search)) !== -1;
    })
    .sort((a, b) => {
      return a.value < b.value ? -1 : 1;
    });

  const pages =
    filteredMessages.length % 10 === 0
      ? parseInt(filteredMessages.length / 10)
      : parseInt(filteredMessages.length / 10) + 1;

  return (
    <div className="App">
      <Container maxWidth="lg" sx={{ pb: 4 }}>
        {profile.isLoaded && (
          <>
            <Grid item xs={12}>
              {configuration && configuration.osMessages && (
                <Text configuration={configuration} propName="osMessages" />
              )}
            </Grid>
            <Grid>
              <Grid width="100%" alignItems="center" container>
                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth className={classes.formControl}>
                    <TextField
                      variant="outlined"
                      label="Buscar (por nombre de obra social / sigla)"
                      onChange={(event) => setSearch(event.target.value)}
                    />
                  </FormControl>
                </Grid>
                <Grid item sm={8}>
                  <Box className={classes.addLy}>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => setShowAddOSMessage(!showAddOSMessage)}
                    >
                      Agregar
                    </Button>
                  </Box>
                </Grid>
              </Grid>
              {pages > 1 && filteredMessages.length > 0 ? (
                <Box display="flex" justifyContent="center" my={4}>
                  <Pagination
                    siblingCount={0}
                    count={pages}
                    color="primary"
                    page={page}
                    onChange={(e, value) => setPage(value)}
                  />
                </Box>
              ) : null}
              {showAddOSMessage && (
                <Message
                  inputs={inputsCreate}
                  initialState={{}}
                  mode="create"
                  index="-1"
                  type=""
                  onDanger={() => setShowAddOSMessage(false)}
                  onSuccess={handleSubmit}
                />
              )}
              {filteredMessages.slice((page - 1) * 10, page * 10).map(({ index, ...osMessage }) => (
                <Message
                  key={index}
                  inputs={inputsUpdate}
                  initialState={osMessage}
                  mode="update"
                  index={index}
                  type=""
                  onDanger={handleDelete}
                  onSuccess={handleSubmit}
                />
              ))}
              {pages > 1 && filteredMessages.length > 0 ? (
                <Box display="flex" justifyContent="center" my={4}>
                  <Pagination
                    siblingCount={0}
                    count={pages}
                    color="primary"
                    page={page}
                    onChange={(e, value) => setPage(value)}
                  />
                </Box>
              ) : null}
            </Grid>
          </>
        )}
      </Container>
    </div>
  );
}

export default OSMessages;
